<div class="groupa-container" [ngStyle]="{ display: tabVisibile ? 'block' : 'none' }">
  <ng-template [cdkPortalOutlet]="_contentPortal"><ng-content></ng-content></ng-template>
</div>
